module.exports = __webpack_public_path__ + "img/icon-prev.e460db20.svg";